module.exports = __webpack_public_path__ + "static/media/ic-close.f2009807.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/ic-close.svg
// module id = 304
// module chunks = 0